import React, { useContext, useState, useEffect } from 'react'
import AppLayout from '../layouts/AppLayout'
import DataTable from '../components/DataTable'
import { AppContext } from '../contexts/AppContext'
import { Link } from 'react-router-dom'
import Spinner from 'react-activity/dist/Spinner'
import 'react-activity/dist/Spinner.css'
import Swal from 'sweetalert2'
import { HiArrowNarrowRight } from 'react-icons/hi'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale'
import { WorkTitleCell } from '../components/WorkCover'
import { WORK_STATUSES } from '../constants/domain'

// Works (audio titles) under monitoring; each row is a Work in one reporting period
const AllMatches = () => {
  const { getmatches, deletematch, isLoading } = useContext(AppContext)

  const [matches, setMatches] = useState([])
  const [statusFilter, setStatusFilter] = useState('')

  const handleDelete = async (match) => {
    if (!isLoading) {
      try {
        const result = await Swal.fire({
          title: 'Are you sure to delete?',
          text: "You won't be able to undo this action",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#E51A4D',
          cancelButtonColor: '#2F2F2F',
          confirmButtonText: 'Yes, Delete',
        })

        if (result.isConfirmed) {
          let response = await deletematch(match)
          if (response === 'success') {
            fetchMatches()
          }
        }
      } catch (error) {
        Swal.fire('An Error Occurred', error, 'error')
      }
    }
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'Work',
        accessor: 'title',
        Cell: ({ row }) => (
          <Link to={`/match-details/${row.original.matchid}`}>
            <WorkTitleCell work={row.original} />
          </Link>
        ),
      },
      { Header: 'Category', accessor: 'compname' },
      { Header: 'Language', accessor: 'language' },
      { Header: 'Period', accessor: 'matchday' },
      {
        Header: 'Monitoring since',
        accessor: 'date',
        Cell: ({ row }) => format(new Date(row.original.date), 'EEE, do MMM yyyy', { locale: enUS }),
      },
      { Header: 'Status', accessor: 'status' },
      {
        Header: 'Actions',
        accessor: 'actions',
        Cell: ({ row }) => (
          <div className='flex items-center space-x-2'>
            <Link
              className='block btn-main-alt-inv !py-1 !px-3 !rounded-sm !text-[12px]'
              to={`/match-details/${row.original.matchid}`}
            >
              View Details
            </Link>
            <Link
              className='text-edit'
              to={`/edit-match/${row.original.matchid}`}
            >
              Edit
            </Link>
            <button
              className='text-delete'
              onClick={() => handleDelete(row.original.matchid)}
            >
              Delete
            </button>
          </div>
        ),
      },
      { Header: 'Added At', accessor: 'addedatdate' },
    ],
    []
  )

  const fetchMatches = async () => {
    const response = await getmatches(statusFilter)
    setMatches(response)
  }

  useEffect(() => {
    fetchMatches()
  }, [statusFilter])

  return (
    <AppLayout pageName='All Works'>
      <section>
        <div className='flex justify-between flex-wrap'>
          <div className='mb-4'>
            <label
              htmlFor='statusFilter'
              className='mb-1'
            >
              Filter by Status
            </label>
            <select
              id='statusFilter'
              name='statusFilter'
              className='form-control'
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value=''>All</option>
              {WORK_STATUSES.map((s) => (
                <option
                  key={s}
                  value={s}
                >
                  {s}
                </option>
              ))}
            </select>
          </div>
          <div className='mb-4'>
            <Link
              className='inline-block'
              to='/add-match'
            >
              <button className='btn-main-inverse'>
                Add new Work <HiArrowNarrowRight />
              </button>
            </Link>
          </div>
        </div>

        {isLoading ? (
          <div className='flex justify-center w-full py-12'>
            <Spinner
              color='#CCCCCC'
              size={24}
            />
          </div>
        ) : (
          <DataTable
            data={matches}
            columns={columns}
          />
        )}
      </section>
    </AppLayout>
  )
}

export default AllMatches
